import MovementTrendChart from './MovementTrendChart';

export default MovementTrendChart;

export type { IMovementTrendChartProps } from './MovementTrendChart';
